module.exports = __webpack_public_path__ + "img/setup-test-step-2-mobile.5a5ac543.png";